import UserAndUserGroupManageComponent, { UserAndUserGroupManagePropsType } from './UserAndUserGroupManageComponent';

const CustomComponent = (props: any) => {
    const { userId, closeModal } = props;
    const apiId = 'userEntrepot';
    //表头
    const columnsHead = [
        {
            title: '用户',
            dataIndex: 'user',
            render: (text: any) => (typeof text !== "undefined" && text !== null ?
                text.userName :
                '')
        },
        {
            title: '仓库',
            dataIndex: 'entrepot',
            render: (text: any) => (typeof text !== "undefined" && text !== null ?
                text.entrepotName :
                '')
        }
    ];
    let extendProps: UserAndUserGroupManagePropsType = {
        mode: 'user',
        titleName: '用户仓库管理',
        apiId,
        userOrUserGroupId: userId,
        columnsHead,
        closeModal,
        options: {
            showDefault: true
        }
    }

    return (
        <>
            <UserAndUserGroupManageComponent extendData={extendProps} ></UserAndUserGroupManageComponent>
        </>
    )
}

export default CustomComponent;